import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CustomPortal from '../../commonComponents/CustomPortal';
import { useUpdatePromotion } from '../../../domain/Promotions';
import { Colors } from '../../../themes/colors';
import { parseErrorMessage } from './utils';

const COPY = {
  disable: {
    text: 'Are you sure you want to disable this promotion?',
    submitText: 'Yes, disable',
    disabled: true,
  },
  reactivate: {
    text: 'Are you sure you want to re-activate this promotion?',
    submitText: 'Yes, re-activate',
    disabled: false,
  },
};

export const DisablePromotionModal = ({ promotion, onClose, onDisabled, mode }) => {
  const [errorMessage, setErrorMessage] = useState('');
  const copy = COPY[mode] || COPY.disable;

  const updateMutation = useUpdatePromotion({
    onSuccess: () => {
      onDisabled?.();
      onClose();
    },
    onError: (error) => setErrorMessage(parseErrorMessage(error)),
  });

  return (
    <CustomPortal
      title=""
      text={copy.text}
      textStyle={{ textAlign: 'center' }}
      cancelText="No, Keep"
      submitText={copy.submitText}
      cancelPressed={onClose}
      submitPressed={() =>
        updateMutation.mutate({
          promotionId: promotion.id,
          changes: { disabled: copy.disabled },
        })
      }
      rightButtonDisabled={updateMutation.isPending}
    >
      {errorMessage && (
        <p style={{ color: Colors.error_500, textAlign: 'center', marginTop: 8 }}>
          {errorMessage}
        </p>
      )}
    </CustomPortal>
  );
};

DisablePromotionModal.propTypes = {
  promotion: PropTypes.shape({ id: PropTypes.string }).isRequired,
  onClose: PropTypes.func.isRequired,
  onDisabled: PropTypes.func,
  mode: PropTypes.oneOf(['disable', 'reactivate']),
};

DisablePromotionModal.defaultProps = {
  onDisabled: undefined,
  mode: 'disable',
};
